import {request } from "@/request";
import { Modal, message } from "ant-design-vue";
const Message = message;
import router from '../../src/router'
import { asyncRouterMap, routes} from '../../src/router';
import  {filterProvinceManage}  from '../plugins/checkpermission'

import  {permissionsTabs,permissionsBtn}  from '../config/user'


const getTableSeleted=({ commit }, tableSelect) => {
  commit("SET_TABLE_SELECT", tableSelect);
};



/**
 * 不同用户登录进来展示不同的标签页
 * @param orgType 登录返回不同用户类型
 */
const setTabPermissions = ({ commit }, orgType) =>{
      const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));
      let orgPermissType = orgType;
      const permissions = permissionsTabs;

      if(orgPermissType == 4 &&filterProvinceManage(userInfo.privilege.menu)){
        orgPermissType = "4|manage";
      }
      if(userInfo.user.monitor == 1){
        let orgPermissTypeBtn = "monitor";
        commit("SET_BTN", permissionsBtn[orgPermissTypeBtn]);
      }else {
        if(userInfo.privilege){
          if(userInfo.privilege.module){
            commit("SET_BTN", userInfo.privilege.module);
          }
        }
        // commit("SET_BTN", permissionsBtn[orgPermissType]);
      }
      let TabsObj = {};
      for(const el of permissions[orgPermissType]){
        TabsObj[el.code] = el.title
      }
      commit("SET_TABS_NAME_OBJ", TabsObj);
      commit("SET_TABS", permissions[orgPermissType]);
};


const setMenuState = ({ commit }, type) => {
  commit("SET_MENU_STATE", type);
};



/**
 * 表格头配置
 */
const setTableHeader = ({ commit }, columns) => {
  commit("SET_TABLE_COLUMNS", columns);
};

const isLoading = ({ commit }, isloading) => {
  commit("IS_LOADING", isloading);
};

function hasPermission(roles, route) {
  return roles.some(role => role.code==route )

  // let flag = roles.some((role) =>{
  //    if(role.hasOwnProperty('show')){
  //      return role.code==route && role.show == 1;
  //    }
  //
  //  })
  // return flag;
}
function routersIndex(roles, route){
  return roles.findIndex(role => role.code==route)
}
const setRouterTags=({ commit }, route) => {
  commit("SET_ROUTER_TAGS", route);
};

const deleteRouterTags=({ commit }, route) => {
  commit("DELETE_ROUTE_TAGS", route);
};





const GenerateRoutes=async ({ commit }, data) => {
  let roles=data;
  const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));
  if(userInfo.user.superuser==1){

    await router.addRoutes(asyncRouterMap)
    commit("SET_ROUTERS", ['a']);
  }
  else{
    const accessedRouters = await asyncRouterMap.filter(v=>{

      if(hasPermission(roles,v.name)){
        let index=routersIndex(roles,v.name)
        let obj = roles.find(item => item.code == v.name);
        if(obj.hasOwnProperty('show')){
          v.meta.show = obj.show
        }else{
          v.meta.show = 0
        }
        if(v.children&&v.children.length!==0){
          v.children = v.children.filter(child => {
            if(roles[index].hasOwnProperty('children')){
              let index2=routersIndex(roles[index].children,child.name)
              if (hasPermission(roles[index].children, child.name)) {
                let obj2 = roles[index].children.find(item => item.code == child.name);
                if(obj2.hasOwnProperty('show')){
                  child.meta.show = obj2.show
                }else{
                  child.meta.show = 0
                }

                if(child.children && child.children.length!==0){
                  child.children = child.children.filter(child2 => {

                    let index3=routersIndex(roles[index].children[index2].children,child2.name)
                    if (hasPermission(roles[index].children[index2].children, child2.name)) {
                      let obj3 = roles[index].children[index2].children.find(item => item.code == child2.name);
                      if(obj3.hasOwnProperty('show')){
                        child2.meta.show = obj3.show
                      }else{
                        child2.meta.show = 0
                      }
                      return child2
                    }
                    return false;
                  });
                }

                return child
              }
              return false;
            }

          });
        }

        return v;
      }
      return false

      // roles.some(role=>{
      // })

    })

    // router.options.routes
       console.log(accessedRouters,'--')
    await router.addRoutes(accessedRouters)
    // router.addRoute(...accessedRouters)

    commit("SET_ROUTERS", accessedRouters);
  }
};


/**
 * 获取表格数据
 */
const getTableData = async ({ commit }, params) => {
  commit("IS_LOADING", true);
  const obj = await request(params.obj,params.query);
  //const { code, message, data}=obj;
  const { code, message, data}=obj;
  if (code) {
    Message.error(message);
  } else {
    commit("GET_TABLE_DATA", data);
    commit("IS_LOADING", false);
  }
};


export default {
  getTableData,
  setMenuState,
  GenerateRoutes,
  setTabPermissions,
  setRouterTags,
  deleteRouterTags,
  getTableSeleted,
  setTableHeader,
  isLoading
};



// WEBPACK FOOTER //
// ./src/store/actions.js